// Centralised route gate for ads.
//
// Banner ads should only ever render on routes that start
// with `/panel` or `/blog`. Keeping this in one place avoids divergent checks
// scattered across AdContext / AdLayout.
export function isAdAllowedRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return (
    pathname.startsWith('/panel') ||
    pathname.startsWith('/blog') ||
    pathname.startsWith('/forums') ||
    pathname.startsWith('/create')
  );
}
